import { Component, OnInit } from '@angular/core';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';
import { DynamicContentModelsByType } from '../../dynamic-content/dynamic-content.map';
import { TranslateService } from '@services/translate/translate.service';
import { HttpClient } from '@angular/common/http';
import { PendingChangesGuard } from '../../../guards/pending-changes.guard';
import * as _ from 'lodash';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { DialogService } from '@services/dialog/dialog.service';
import moment from 'moment/moment';
import { LanguageSelectorComponent } from '../../../components/language-selector/language-selector.component';
import { MatDialog } from '@angular/material/dialog';
import { DeeplTranslationService } from '@services/deepl-translation/deepl-translation.service';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { OrganisationService } from '@services/organisations/organisation.service';
import { AddItemsFromList } from '../../user-admin/user-admin-edit/dialogs/add-items-from-list/add-items-from-list.component';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-content-pool',
  templateUrl: './content-pool-edit.component.html',
  styleUrls: ['./content-pool-edit.component.scss'],
  providers: [DynamicContentService, PendingChangesGuard, DeeplTranslationService, OrganisationService],
  standalone: false
})
export class ContentPoolEditComponent implements OnInit {
  public dynamicContentHistory = null;
  public translationEntries = {};
  public translationEntriesHistory = null;
  public contact = { email: null, phone: null };
  public type: string;
  public create = false;
  public dynamicContent: any;
  public availableLanguages = ['de', 'en', 'it', 'fr'];
  public languages = ['de'];
  public isLoading = true;
  lang = 'de';
  isTranslating = false;
  iframeVisible = false;
  selectedIndex = 0;
  pageError;
  masterLanguage;
  selectedLanguage = 'de';
  pageActions: PageAction[] = [
    new PageAction({ icon: 'subdirectory_arrow_left', title: 'Back', translationString: 'general.back', callback: () => this.backPage() }),
    new PageAction({ icon: 'save', id: 'save', title: 'Save', translationString: 'general.save', callback: () => this.save() })
  ];
  stops = [];
  currentSearchTerm;
  searchTerms = [];
  translations;
  alreadyChecked = true;
  urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9_-]+\.[a-z]{2,}([\/a-zA-Z0-9#%&=?.:_~-]*)?$/;
  id;
  public contentIsEmpty = false;
  public isUsedByTranslation = false;
  dynamicContentTitles = {
    information: 'Informationen', activity: 'Aktivitäten', alphabet: 'Alphabet', offer: 'Angebote', 'breaking-news': 'Breaking News', event: 'Events', feedback: 'Feedback',
    gallery: 'Gallery', gastronomy: 'Gastronomie', memory: 'Memory', new: 'News', 'public-transport': 'Öffentlicher Verkehr', 'opening-hours': 'Öffnungszeiten', person: 'Personen',
    pinboard: 'Pinboard', quiz: 'Quiz', restaurant: 'Restaurants', screensaver: 'Screensaver', 'social-media': 'Social Media', ticker: 'Ticker', voting: 'Voting', webcam: 'Webcams',
    'important-numbers': 'Wichtige Nummern', roomservice: 'Zimmerservice'
  };
  private searchTimeout: any;
  columns = [{ prop: 'title', name: 'Name' }];
  organisations: Models.Organisation[] = [];
  assignedOrganisations: Models.Organisation[] = [];
  headerButtons = [{ icon: 'add', callback: () => this.addOrganisation() }];
  constructor(
    private activatedRoute: ActivatedRoute, private router: Router, public contentService: DynamicContentService, private ts: TranslateService, public http: HttpClient,
    private snackbar: SnackbarService, private dialogService: DialogService, private dialog: MatDialog, private translation: DeeplTranslationService, private orgService: OrganisationService
  ) {
  }

  async ngOnInit() {
    this.initTranslations();
    this.type = this.activatedRoute.snapshot.params['type'];
    this.id = this.activatedRoute.snapshot.params['id'];
    this.create = this.activatedRoute.snapshot.url[1].path === 'create';
    this.organisations = await this.getOrganisations({ tag: { $ne: 'static' } });
    await (this.create ? this.createContent() : this.initContent());
  }

  async getOrganisations(params = {}) {
    let result = [];
    let organisations = await this.orgService.find(0, 100, params);
    result = result.concat(organisations.data);
    let i = 1;
    while (result.length < organisations.total) {
      organisations = await this.orgService.find(i * 100, 100, params);
      result = result.concat(organisations.data);
      i++;
    }
    return result;
  }

  async createContent() {
    const modelMap: { [key: string]: string } = {
      'category': 'ContentGastronomy', 'breaking-news': 'ContentDefault', 'gastronomy': 'ContentGastronomy', 'activity': 'ContentActivity',
      'information': 'ContentDefault', 'webcam': 'ContentWebcam', 'voting': 'ContentVoting', 'opening-hours': 'ContentOpeningHours', 'event': 'ContentEvent',
      'important-numbers': 'ContentImportantNumbers', 'quiz': 'ContentQuiz', 'social-media': 'ContentSocialMedia', 'ticker': 'ContentTicker', 'voucher': 'ContentVoucher',
      'public-transport': 'ContentPublicTransport'
    };

    this.dynamicContent = <Models.DynamicContentBase>Models.ModelFactory.createModelInstanceByName(DynamicContentModelsByType.get(this.type));
    this.dynamicContent.published = true;
    this.dynamicContent.organisationIds = ['all'];
    this.dynamicContent = this.initDynamicContentByType(this.dynamicContent);
    this.dynamicContent.global = true;
    Object.assign(this.dynamicContent, {
      title: '', lang: 'de', isMainNavigation: true, translationEntries: [],
      dailyIntervalPublish: { start: null, end: null }, masterLanguageEntry: '', type: this.type, mediaFiles: [], dataFiles: []
    });
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);

    if (this.type === 'category') this.dynamicContent.published = true;
    if (this.type === 'breaking-news') this.dynamicContent.content.date = new Date();

    this.handleAdditionalFieldsAfter();

    if (this.type === 'gastronomy') {
      /*const children = this.parent instanceof Models.DynamicContentEntrance ? await this.contentService.find(0, 100, { _id: { $in: this.parent.children } }) : null;
      const element = children?.data?.length ? children.data.sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime())[0] : null;
      this.dynamicContent.content = <Models.ContentGastronomy>Models.ModelFactory.createModelInstanceByName('ContentGastronomy', element?.content);*/
    } else if (['activity', 'information', 'webcam', 'voting', 'opening-hours', 'important-numbers', 'quiz', 'social-media', 'voucher', 'event'].includes(this.type)) {
      this.dynamicContent.content = <Models.ContentDefault>Models.ModelFactory.createModelInstanceByName(modelMap[this.type]);
    }
    this.isLoading = false;

    this.dynamicContent.content['textContent'] = null;
    setTimeout(() => {
      this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    }, 500);
  }

  async initContent() {
    let assigned;
    try {
      assigned = await this.contentService.getAssigned(this.id);
    } catch (err) {
      this.isLoading = false;
      this.pageError = err.message;
      return null;
    }
    if (!assigned) return null;
    if (assigned?.content?.organisationIds?.length) {
      this.assignedOrganisations = this.organisations.filter(o => assigned.content.organisationIds.includes(o.OrganisationID));
    }
    this.dynamicContent = this.initDynamicContentByType(assigned.content);
    this.dynamicContent.content.textContent = this.cleanUpQuillContent(this.dynamicContent.content.textContent);
    this.dynamicContent.mediaFiles = this.dynamicContent.mediaFiles || [];
    this.dynamicContent.dataFiles = this.dynamicContent.dataFiles || [];
    this.dynamicContent.dailyIntervalPublish = this.dynamicContent.dailyIntervalPublish || { start: null, end: null };
    this.handleAdditionalFieldsAfter();

    assigned.translations?.forEach(translation => {
      this.translationEntries[translation.lang] = translation;
      this.languages.push(translation.lang);
    });

    const translationEntriesCopy = JSON.stringify(this.dynamicContent.translationEntries);
    assigned.translations?.forEach(translation => {
      if (!this.dynamicContent?.translationEntries?.includes(translation?._id?.toString()) && !!translation?._id?.toString()?.length) {
        this.dynamicContent.translationEntries.push(translation._id.toString());
      }
    });
    if (translationEntriesCopy !== JSON.stringify(this.dynamicContent.translationEntries)) {
      await this.contentService.update(this.dynamicContent._id, this.dynamicContent);
    }
    this.checkContent();
    this.isLoading = false;
    setTimeout(() => {
      this.translationEntriesHistory = JSON.stringify(this.translationEntries);
      this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    }, 500);
    this.iframeVisible = !!this.dynamicContent?.content?.iframe;
  }

  initDynamicContentByType(dynamicContent: Models.DynamicContent) {
    if (['gastronomy', 'activity', 'voting', 'webcam', 'important-numbers', 'quiz', 'social-media', 'ticker', 'person', 'event', 'public-transport'].includes(this.type)) {
      let typeName = JSON.parse(JSON.stringify(this.type)).replace(/[-_]+(.)?/g, (a, c) => (c ? c.toUpperCase() : ''));
      let content = <any>Models.ModelFactory.createModelInstanceByName('Content' + typeName.charAt(0).toUpperCase() + typeName.slice(1), dynamicContent.content);
      if (this.type === 'event') {
        content.multipleDates = dynamicContent.content.multipleDates;
        content.dates = dynamicContent.content.dates;
      }
      dynamicContent.content = content;
    }
    return dynamicContent;
  }

  handleAdditionalFieldsAfter() {
    if (!['restaurant', 'event', 'offer', 'opening-hours', 'information', 'voucher'].includes(this.type)) {
      return;
    }
    if (Array.isArray(this.dynamicContent.content.contact)) {
      this.dynamicContent.content.contact.forEach(contact => {
        if (contact.type === 'email') this.contact.email = contact.value;
        if (contact.type === 'phone') this.contact.phone = contact.value;
      });
    } else {
      this.dynamicContent.content.contact = new Models.ContactVariants();
    }

    const { location } = this.dynamicContent.content;
    this.dynamicContent.content.location = {
      ...new Models.Location(), address: location?.address, zip: location?.zip, city: location?.city,
      coordinates: { ...new Models.GeoLocation(), latitude: location?.coordinates?.latitude, longitude: location?.coordinates?.longitude }
    };
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
  }

  async changeLanguage() {
    const result = await this.dialog.open(LanguageSelectorComponent, <any>{
      width: '656px', data: { selected: this.languages, available: this.availableLanguages, type: (this.dynamicContent._id ? 'add' : 'change') }
    }).afterClosed().toPromise();
    if (!result) {
      return;
    } else if (result.type === 'add') {
      this.translationEntries[result.lang] = <Models.DynamicContentBase>Models.ModelFactory.createModelInstanceByName(DynamicContentModelsByType.get(this.type));
      this.translationEntries[result.lang] = this.initDynamicContentByType(this.translationEntries[result.lang]);
      this.translationEntries[result.lang].lang = result.lang;
      this.translationEntries[result.lang].masterLanguageEntry = this.dynamicContent._id;
      this.translationEntries[result.lang].type = this.type;
      this.languages.push(result.lang);
      this.selectedIndex = this.languages ? this.languages.length - 1 : 0;
      this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    }
  }

  async removeLanguage(lang: string, event: any) {
    event.stopPropagation();
    if (!await this.dialogService.confirm(this.translations['system']['general']['removeTranslation'])) return;
    if (this.translationEntries[lang]._id) await this.contentService.remove(this.translationEntries[lang]._id);
    delete this.translationEntries[lang];
    this.languages = this.languages.filter(language => language !== lang);
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    this.snackbar.success(`${lang}${this.translations['system'].dynamicContent.lang_saved}`);
  }

  async save(): Promise<any> {
    for (let lang of this.languages) {
      await this.saveByLanguage(lang);
    }
    this.snackbar.success(this.translations.system.dynamicContent.saved);
    return true;
  }

  private async saveByLanguage(language): Promise<any> {
    if (this.dynamicContent.content.multipleDates) {
      this.dynamicContent.content.dates = this.dynamicContent.content.multipleDates[0];
    }

    if (this.type === 'person') {
      this.dynamicContent.title = this.dynamicContent.content.lastname + ' ' + this.dynamicContent.content.firstname;
    }

    if (this.dynamicContent.publishEnd) {
      if ((<any>this.dynamicContent.publishEnd).setHours) {
        (<any>this.dynamicContent.publishEnd).setHours(23, 59, 59, 999);
      }
      if ((<any>this.dynamicContent.publishEnd).hours) {
        (<any>this.dynamicContent.publishEnd).hours(23, 59, 59, 999);
      }
    }
    const isTranslation = language !== this.dynamicContent.lang;
    try {
      await this.validateContent(isTranslation, language);
    } catch (err) {
      await this.dialogService.confirm(err.message);
      return Promise.reject(err);
    }
    this.checkContent();
    this.handleAdditionalFields();
    if (isTranslation) {
      this.translationEntries[language].content.textContent = this.cleanUpQuillContent(this.translationEntries[language].content.textContent);
      if (!this.translationEntries[language]._id) {
        return this.addTranslationLanguage(this.translationEntries[language], language);
      } else {
        return this.updateTranslationLanguage(this.translationEntries[language], language);
      }
    } else {
      if (!this.dynamicContent._id) {
        await this.addMasterLanguage();
        this.alreadyChecked = true;
        return await this.router.navigate(['content-pool', this.type, this.dynamicContent._id]);
      }
      this.dynamicContent.content.textContent = this.cleanUpQuillContent(this.dynamicContent.content.textContent);
      const res = await this.updateMasterLanguage();
      this.handleAdditionalFieldsAfter();
      return res;
    }
  }

  async addMasterLanguage() {
    const result = await this.contentService.create(this.dynamicContent);
    this.dynamicContent = result;
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    return result;
  }

  async updateMasterLanguage(): Promise<any> {
    this.dynamicContent = await this.contentService.patch(this.dynamicContent._id, this.dynamicContent);
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    return this.dynamicContent;
  }

  async addTranslationLanguage(dynamicContent, lang) {
    const result = await this.contentService.create(dynamicContent);
    this.dynamicContent.translationEntries.push(result._id);
    await this.contentService.update(this.dynamicContent._id, this.dynamicContent);
    this.translationEntries[lang] = result;
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    this.dynamicContentHistory = JSON.stringify(this.dynamicContent);
    return result;
  }

  async updateTranslationLanguage(dynamicContent, lang) {
    this.translationEntries[lang] = await this.contentService.patch(dynamicContent._id, dynamicContent);
    this.translationEntriesHistory = JSON.stringify(this.translationEntries);
    return this.translationEntries;
  }

  cleanUpQuillContent(content, lang?) {
    content = content ? content.replace(/&nbsp;/gm, ' ') : content;
    return content ? content.replace(/(<p>(<\w*>)*(<br>)*(<\/\w*>)*<\/p>)+$/gm, '') : content;
  }

  handleAdditionalFields() {
    if (!['restaurant', 'event', 'offer', 'opening-hours', 'information', 'voucher'].includes(this.type)) {
      return;
    }
    const contactTypes = [{ type: 'email', value: this.contact.email }, { type: 'phone', value: this.contact.phone }];
    this.dynamicContent.content.contact = contactTypes.filter(contact => contact.value && contact.value.length);
    if ('opening-hours' === this.type) {
      this.dynamicContent.content.openingHours = this.dynamicContent.content.openingInfo;
    }
    if ('event' === this.type && !this.dynamicContent.content.repeating) {
      const setDate = (date, time) => {
        if (time) {
          date.hours(parseInt(time.split(':')[0], 10));
          date.minutes(parseInt(time.split(':')[1], 10));
        }
        return date.unix();
      };

      if (!this.dynamicContent.content.validity) {
        this.dynamicContent.content.validity = { };
      }
      if (this.dynamicContent.publishStart) {
        this.dynamicContent.content.validity.start = setDate(moment(this.dynamicContent.publishStart), this.dynamicContent.publishStartTime);
      } else if (this.dynamicContent.content.dates.startDate) {
        this.dynamicContent.content.validity.start = new Date(this.dynamicContent.content.dates.startDate).getTime() / 1000;
      }

      if (this.dynamicContent.publishEnd) {
        this.dynamicContent.content.validity.end = setDate(moment(this.dynamicContent.publishEnd), this.dynamicContent.publishEndTime);
      } else if (this.dynamicContent.content.dates.endDate) {
        this.dynamicContent.content.validity.end = new Date(this.dynamicContent.content.dates.endDate).getTime() / 1000;
      }
    }
  }

  async validateContent(isTranslation, language): Promise<any> {
    const isValidUrl = (url: string): boolean => this.urlRegex.test(url);
    const rejectWithMessage = (message: string) => Promise.reject({ message });
    if (!(!!isTranslation ? this.translationEntries[language]?.title : this.dynamicContent.title)) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.title);
    }
    if ((!!isTranslation ? this.translationEntries[language]?.content?.iframe : this.dynamicContent.content.iframe)
      && !isValidUrl((!!isTranslation ? this.translationEntries[language]?.content?.iframe : this.dynamicContent.content.iframe).trim())) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.inputFieldError);
    }
    if ((!!isTranslation ? ((this.translationEntries[language]?.content?.bookingText || this.translationEntries[language]?.content?.bookingTextScreen) && !this.translationEntries[language]?.content?.bookingUrl) :
      ((this.dynamicContent?.content?.bookingText || this.dynamicContent?.content?.bookingTextScreen) && !this.dynamicContent?.content?.bookingUrl))) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.provideUrl);
    }
    if (this.type === 'event' && !this.dynamicContent.content.repeating) {
      if (!this.dynamicContent?.content?.dates?.startDate) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.eventStartDate);
      }
    } else if (this.type === 'event' && !!this.dynamicContent.content.repeating) {
      const { repetitionSize: size, repetitionRhythm: rhythm } = this.dynamicContent?.content?.repetition || {};
      if (['day', 'week'].includes(size) && !this.dynamicContent?.content?.repetition?.weekdays?.length) {
        return rejectWithMessage(this.translations['system'].dynamicContent.validation.weekdays);
      }
    }
    if (this.type === 'breaking-news' && !this.dynamicContent.content.date) {
      return rejectWithMessage(this.translations['system'].dynamicContent.validation.date);
    }

    if (this.type === 'voting') {
      if (this.dynamicContent.content.textContent.length > 180) return rejectWithMessage(this.translations.system.dynamicContent.validation.textContentLength);
      if (this.dynamicContent.content.answers.some(a => a.length > 80)) return rejectWithMessage(this.translations.system.dynamicContent.validation.answerLength);

      if (this.dynamicContent.content.type === 'scale') {
        if (!this.dynamicContent.content.scaleIcon) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleIcon);
        if (this.dynamicContent.content.scaleIcon === 'numeric') {
          const step = parseFloat(this.dynamicContent.content.scaleStep);
          if (!step || isNaN(step)) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleStep);
          if (step <= 0) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleStepZero);
        } else {
          if (isNaN(this.dynamicContent.content.scaleMax)) return rejectWithMessage(this.translations.system.dynamicContent.validation.notNumber);
          if (this.dynamicContent.content.scaleMax > 6) return rejectWithMessage(this.translations.system.dynamicContent.validation.scaleMax);
        }
      }
    }

    if (['opening-hours', 'restaurant'].includes(this.type) && this.dynamicContent.content.openingHours) {
      const { regularOpeningHours, exceptionDays } = this.dynamicContent.content.openingHours;
      for (const key in regularOpeningHours) {
        if (regularOpeningHours[key]?.open) {
          for (const { startTime, endTime } of regularOpeningHours[key].times) {
            if (!startTime || !endTime)
              return rejectWithMessage(this.translations.system.dynamicContent.validation.regularOpeningHoursTimes);
          }
        }
      }

      if (exceptionDays) {
        for (let i = 0; i < exceptionDays.length; i++) {
          if (!exceptionDays[i]?.title || !exceptionDays[i]?.date) {
            if (!exceptionDays[i]?.open && !exceptionDays[i]?.title && !exceptionDays[i]?.date) {
              exceptionDays.splice(i--, 1);
              continue;
            }
            return rejectWithMessage(this.translations.system.dynamicContent.validation.exceptionDays);
          }
          if (exceptionDays[i]?.open) {
            for (const { startTime, endTime } of exceptionDays[i]?.times) {
              if (!startTime || !endTime)
                return rejectWithMessage(this.translations.system.dynamicContent.validation.regularOpeningHoursTimes);
            }
          }
        }
      }
    }

    return Promise.resolve(true);
  }

  tabChanged(event) {
    this.selectedLanguage = this.languages[event.index];
  }

  onEditorChange(event, target, lang?) {
    (!!lang ? this.translationEntries[lang] : this.dynamicContent).content[target] = event;
  }

  async translateTitleFromMainLanguage(lang: string) {
    this.isTranslating = true;
    this.translationEntries[lang].title = await this.translation.translate(this.dynamicContent.title, lang);
    this.isTranslating = false;
  }

  getTitle(): string {
    return [this.ts.get('pages.content-pool'), this.dynamicContentTitles[this.type], this.dynamicContent?.title || this.ts.get('dynamicContent.create')].join(' > ');
  }

  searchStop(index?: number) {
    setTimeout(() => {
      let term = index !== undefined ? this.searchTerms[index] : this.currentSearchTerm;
      if (term?.length > 2) {
        return this.http.post(environment.apiBaseURL + '/public-transport/stop', { term }).toPromise().then((res: any) => {
          this.stops = res;
        }).catch(err => {
          console.warn(err);
        });
      }
    }, 50);
  }

  selectStop(stop: any, index?: number) {
    stop = _.clone(_.find(this.stops, { stopId: stop.option.value }));
    if (index !== undefined) {
      this.dynamicContent.content.additionalStops[index].stopId = stop.stopId;
      this.dynamicContent.content.additionalStops[index].stopName = stop.name;
      this.searchTerms[index] = null;
    } else {
      this.dynamicContent.content.stopId = stop.stopId;
      this.dynamicContent.content.stopName = stop.name;
      this.currentSearchTerm = null;
    }
  }

  addStop() {
    if (!this.dynamicContent?.content?.additionalStops) {
      this.dynamicContent.content.additionalStops = [];
    }
    this.dynamicContent.content.additionalStops.push(new Models.ContentPublicTransportAdditionalStop());
  }

  removeStop(index?: number) {
    this.dynamicContent.content.additionalStops.splice(index, 1);
  }

  checkContent() {
    this.contentIsEmpty = !this.dynamicContent.mediaFiles.length && !this.dynamicContent.dataFiles.length;
    if (this.dynamicContent.content.iframe || (this.dynamicContent.content.textContent && this.dynamicContent.content.textContent.length)) {
      this.contentIsEmpty = false;
    }
    if (!this.contentIsEmpty) {
      this.dynamicContent.isNavigationOnly = false;
    }
    this.isUsedByTranslation = !!Object.values(this.translationEntries).find((item: any) => !!item?.useMasterLanguage);
  }

  updateIframeContent(event: any) {
    this.dynamicContent.iframe = null;
    this.iframeVisible = event.val;
    if (!this.iframeVisible) {
      this.dynamicContent.content.iframe = null;
    }
  }

  async initTranslations() {
    this.translations = this.ts.get();
    this.translations['system'] = this.ts.get('system');
  }

  async backPage() {
    await this.router.navigate(['content-pool', this.type]);
  }

  async addOrganisation() {
    const dialogRef = this.dialog.open(AddItemsFromList, {
      width: '1200px',
      data: {
        availableItems: this.organisations.filter(o => !this.assignedOrganisations.find(a => a.OrganisationID === o.OrganisationID)),
        columns: [{ prop: 'title', name: 'Titel' }], idField: 'OrganisationID'
      }
    });
    const result = await dialogRef.afterClosed().toPromise();
    if (!result) {
      return;
    }
    this.dynamicContent.organisationIds = (this.dynamicContent.organisationIds || []).concat(result?.additionalItems || []);
    if (this.dynamicContent.organisationIds.length > 1) {
      this.dynamicContent.organisationIds = this.dynamicContent.organisationIds.filter(o => o !== 'all');
    }
    this.assignedOrganisations = this.organisations.filter(o => this.dynamicContent.organisationIds.includes(o.OrganisationID));
  }

  async removeOrganisation(event: any) {
    const dialogRes = await this.dialogService.confirm('Diesse Organisation wirklich entfernen?', '');
    if (!dialogRes) {
      return;
    }
    this.assignedOrganisations = this.assignedOrganisations.filter(o => o.OrganisationID !== event.row.OrganisationID);
    this.dynamicContent.organisationIds = this.dynamicContent.organisationIds.filter(o => o !== event.row.OrganisationID);
    if (this.dynamicContent.organisationIds.length === 0) {
      this.dynamicContent.organisationIds = ['all'];
    }
  }
}
